<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <system-settings>
        </system-settings> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import SystemSettings from './todo-settings'
export default {
    components: {
        SystemSettings
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-settings/base-settings.vue